import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, FadeIn, Spinner } from 'lib/ui'
import { useCommerceHubTokens, getWalletLabel } from 'lib/modules/commercehub'
import { Item } from './components/Item'
import { Container } from './styled'

export const PaymentHome = () => {
  const history = useHistory()
  const {
    paymentTokens,
    tokensLoading,
    deleteToken,
    tokenIsDeleting
  } = useCommerceHubTokens()

  const isLoading = tokensLoading
  const isUpdating = tokenIsDeleting || tokensLoading

  return (
    <Container isUpdating={isUpdating}>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className='cards'>
          {paymentTokens && !paymentTokens.length && (
            <p>No payment methods yet.</p>
          )}

          {paymentTokens?.map((paymentMethod) => {
            const publicHash = paymentMethod.publicHash
            const { maskedCc, cardholderName, expirationDate, type } = paymentMethod.details
            // A credential stored from a digital wallet carries only what the wallet
            // charge response reported - brand, expiry and cardholder name may be absent.
            const walletLabel = getWalletLabel(paymentMethod.details)
            const cardType = type || walletLabel

            return (
              <Item
                key={publicHash}
                description={cardholderName ?? ''}
                walletLabel={walletLabel}
                card={{
                  expiration: expirationDate ?? '',
                  last4: maskedCc ?? '',
                  type: cardType
                }}
                isDisabled={isUpdating}
                onDelete={() => {
                  const cardLabel = [cardType, maskedCc && `ending in ${maskedCc}`]
                    .filter(Boolean)
                    .join(' ')

                  if (window.confirm(`Delete ${cardLabel || 'this payment method'}?`)) {
                    deleteToken(publicHash)
                  }
                }}
              />
            )
          })}

          <div className='new-card'>
            <FadeIn>
              <Button onClick={() => history.push('/customer/account/payment/commercehub/add')}>
                Add Payment
              </Button>
            </FadeIn>
          </div>
        </div>
      )}
    </Container>
  )
}
